/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ShockEventLevel } from './ShockEventLevel';
import {
    ShockEventLevelFromJSON,
    ShockEventLevelFromJSONTyped,
    ShockEventLevelToJSON,
    ShockEventLevelToJSONTyped,
} from './ShockEventLevel';

/**
 * 
 * @export
 * @interface ShockEventCreate
 */
export interface ShockEventCreate {
    /**
     * The client also provides the event id. This way we don't have to rely on timing based constraints. See `docs/backend/Offline-Synchronization.md` for details.
     * @type {string}
     * @memberof ShockEventCreate
     */
    id: string;
    /**
     * The shock profile that was used to detect the shock event.
     * @type {string}
     * @memberof ShockEventCreate
     */
    shockProfileVersionId: string;
    /**
     * The exact time the shock event occurred at. This has to be the time registered by the Elobox/App.
     * @type {Date}
     * @memberof ShockEventCreate
     */
    time: Date;
    /**
     * The peak gravitational force during the impact. The unit of this value are milliseconds.
     * @type {number}
     * @memberof ShockEventCreate
     */
    gForce: number;
    /**
     * The vehicle that was driven when the event was detected.
     * @type {string}
     * @memberof ShockEventCreate
     */
    vehicleId: string;
    /**
     * The user that drove the vehicle when the event was detected.
     * @type {string}
     * @memberof ShockEventCreate
     */
    userId?: string | null;
    /**
     * The period ID of the vehicle movement that was in progress when the event was detected.
     * @type {string}
     * @memberof ShockEventCreate
     */
    vehicleMovementPeriodId?: string | null;
    /**
     * 
     * @type {ShockEventLevel}
     * @memberof ShockEventCreate
     */
    shockLevel: ShockEventLevel;
    /**
     * 
     * @type {boolean}
     * @memberof ShockEventCreate
     */
    mediumImpactSafe?: boolean | null;
}



/**
 * Check if a given object implements the ShockEventCreate interface.
 */
export function instanceOfShockEventCreate(value: object): value is ShockEventCreate {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('shockProfileVersionId' in value) || value['shockProfileVersionId'] === undefined) return false;
    if (!('time' in value) || value['time'] === undefined) return false;
    if (!('gForce' in value) || value['gForce'] === undefined) return false;
    if (!('vehicleId' in value) || value['vehicleId'] === undefined) return false;
    if (!('shockLevel' in value) || value['shockLevel'] === undefined) return false;
    return true;
}

export function ShockEventCreateFromJSON(json: any): ShockEventCreate {
    return ShockEventCreateFromJSONTyped(json, false);
}

export function ShockEventCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShockEventCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'shockProfileVersionId': json['shockProfileVersionId'],
        'time': (new Date(json['time'])),
        'gForce': json['gForce'],
        'vehicleId': json['vehicleId'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'vehicleMovementPeriodId': json['vehicleMovementPeriodId'] == null ? undefined : json['vehicleMovementPeriodId'],
        'shockLevel': ShockEventLevelFromJSON(json['shockLevel']),
        'mediumImpactSafe': json['mediumImpactSafe'] == null ? undefined : json['mediumImpactSafe'],
    };
}

export function ShockEventCreateToJSON(json: any): ShockEventCreate {
    return ShockEventCreateToJSONTyped(json, false);
}

export function ShockEventCreateToJSONTyped(value?: ShockEventCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'shockProfileVersionId': value['shockProfileVersionId'],
        'time': value['time'].toISOString(),
        'gForce': value['gForce'],
        'vehicleId': value['vehicleId'],
        'userId': value['userId'],
        'vehicleMovementPeriodId': value['vehicleMovementPeriodId'],
        'shockLevel': ShockEventLevelToJSON(value['shockLevel']),
        'mediumImpactSafe': value['mediumImpactSafe'],
    };
}

